import { render, staticRenderFns } from "./workPeople.vue?vue&type=template&id=cb60e984"
import script from "./workPeople.vue?vue&type=script&lang=js"
export * from "./workPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports